<template lang="html">
  <episode-detail
    mode="create"
    :show-slug="showSlug"
  />
</template>

<script>
  // let COS = require('cos-js-sdk-v5')
  import EpisodeDetail from './episode-detail.vue'
  export default {
    components: {
      EpisodeDetail
    },
    data() {
      return {
        showSlug: this.$route.params.slug,
      }
    },
    methods: {
      // goBack () {
      //   this.$router.go(-1)
      // }
    }
  }
</script>

<style lang="css" scoped>
</style>
